import logger from 'utils/logger.util';
import isArrayIndex from 'utils/predicates/number/isArrayIndex.util';

const L = logger('ARRAY');

export const asNewArray = (value) => {
  try {
    if (null === value || value === void 1) return [];

    if (Array.isArray(value)) return [...value];

    return Array.from(value);
  } catch (e) {
    L.warn('asNewArray()', e);
  }
  return [];
};

export const insertAt = (options) => {
  try {
    const { array, what } = options ?? {};
    const index = options?.index ?? 0;
    const isArray = Array.isArray(array);

    if (!isArray) L.warn('()', 'Not an array:', array);

    const clone = isArray ? [...array] : [];

    if (index >= clone.length) {
      clone[index] = what;
      return clone;
    }

    // 0 means nothing is to be deleted
    clone.splice(index, 0, what);

    return clone;
  } catch (e) {
    L.error('insertAt()', e);
    return [];
  }
};

export const deleteAt = (options) => {
  try {
    const index = options?.index ?? 0;
    const isArray = Array.isArray(options?.array);

    if (!isArrayIndex(options?.index)) L.warn('()', 'Not an array index:', index);
    if (!isArray) L.warn('()', 'Not an array:', options?.array);

    const clone = isArray ? [...(options?.array ?? [])] : [];

    if (index >= clone.length) return clone;

    clone.splice(index, 1);

    return clone;
  } catch (e) {
    L.error('deleteAt()', e);
    return [];
  }
};

export const replaceAt = (options) => {
  try {
    const { array, index, what } = options ?? {};
    const isArray = Array.isArray(array);

    if (!isArray) L.warn('()', 'Not an array:', array);
    if (!isArrayIndex(index)) L.warn('()', 'Not an array index:', index);

    const clone = isArray ? [...array] : [];
    clone[index] = what;

    return clone;
  } catch (e) {
    L.error('replaceAt()', e);
    return [];
  }
};
